import React from 'react';
import { Modal, Button } from 'react-bootstrap'
import CloseIcon from '../../layouts/SVG/CloseIcon';
import { GreenIssueIconSVG } from '../../layouts/SVG/GreenIconSVG';

const ReportIssueSuccess = ({ successModalShow, setSuccessModalShow }) => {

  return (
    <>
      <Modal
        centered
        className="modal-report-issue"
        show={successModalShow}
        onHide={() => setSuccessModalShow(false)}
      >
        <Modal.Body>
          <CloseIcon handleModalClose={() => setSuccessModalShow(false)} />
          <GreenIssueIconSVG />
          <Modal.Title as="h4" style={{ margin: '16px 0 8px' }}>
            Thank You for Reporting the Issue
          </Modal.Title>
          <p>
            Your issue report has been received. We appreciate your feedback. Our team is actively
            working on resolving the issue. We will comeback to you shortly. If you have any additional
            details to share, please contact our support team. Your cooperation helps us improve our
            services.
          </p>
          <Button
            variant="primary"
            onClick={() => setSuccessModalShow(false)}
            style={{ minWidth: 160 }}
          >
            Okay
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ReportIssueSuccess

